<template>
  <div class="webinar-buttons">
    <Button v-for="button in buttons" :key="button.id" :href="button.href"
            @click="clickButton(button)">
      {{ button.label }}
    </Button>
  </div>
</template>

<script lang="ts">
import {
  defineComponent, onBeforeUnmount, PropType, ref,
} from 'vue'
import axios from 'axios'
import { Button as B } from '@/types/webinar.d'
import Timeout from '@/types/timeout.d'
import Button from './Button.vue'

export default defineComponent({
  name: 'Buttons',
  props: {
    schedule: {
      type: Number as PropType<number>,
      required: true,
    },
    webinar: {
      type: Number as PropType<number>,
      required: true,
    },
    videoTiming: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Button,
  },
  setup(props) {
    const buttons = ref([])
    let timeout: Timeout
    const getButtons = async () => {
      clearTimeout(timeout)
      buttons.value = await axios.get(`/buttons/${props.schedule}`, {
        params: {
          webinar: props.webinar,
          timing: props.videoTiming,
        },
      })
        .then(({ data }) => (data?.filter ? data.filter((b: B) => b.visibility) : []))
        .catch(() => [])
      timeout = setTimeout(getButtons, 3000)
    }
    onBeforeUnmount(() => clearTimeout(timeout))
    getButtons()
    const clickButton = (button: { href: string, label: string }) => axios.post(`/schedule/${props.schedule}/click-button`, {
      title: button.label,
      href: button.href,
    }).catch(() => false)
    return {
      buttons,
      clickButton,
    }
  },
})
</script>

<style lang="stylus">
.webinar-buttons
  display flex
  flex-wrap wrap
</style>
